import { CSSProperties, useState } from 'react';

import LogoView from './LogoView';

interface IProps {
  url?: string;
  path?: string;
  style?: CSSProperties;
}

const Logo = ({ url, path, style }: IProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <LogoView
      url={url}
      path={path}
      style={style}
      isLoaded={isLoaded}
      onLoad={() => setIsLoaded(true)}
    />
  );
};

export default Logo;
